import React from "react";
import Form from "./form"; 
function App() {
  return (
    <div className="App">
      <Form />
    </div>
  );
}

export default App;
